import {
	PLAYABLE_SOUND_SYNTHS,
	type PlayableSound,
} from "@client/app/hooks/playableSounds";
import { useSoundStore } from "@client/stores/soundStore";
import { playSynth } from "@client/utils/synth";

export type { PlayableSound };

export function playSound(
	sound: PlayableSound | null,
	options?: { ignoreMute?: boolean },
) {
	if (!sound) {
		return;
	}
	if (
		!options?.ignoreMute &&
		!useSoundStore.getState().isSoundEnabled(sound)
	) {
		return;
	}
	playSynth(PLAYABLE_SOUND_SYNTHS[sound]);
}

export const usePlaySound = () => playSound;
